export const providesList = (resultsWithIds = [], tagType) => {
  return resultsWithIds
    ? [{ type: tagType, id: 'LIST' }, ...resultsWithIds.map(({ id }) => ({ type: tagType, id }))]
    : [{ type: tagType, id: 'LIST' }]
}

export const invialidateList = (tagType) => [{ type: tagType, id: 'LIST' }]
export const invialidateListById = (tagType, id) => [{ type: tagType, id }]
